module.exports = __webpack_public_path__ + "img/adulto21.1ef199f7.jpg";